<template>
  <v-container fluid>
    <v-layout layout align-center justify-space-between>
      <v-flex md1 mb-3 class="headline" >
        <v-btn
          dark
          color="primary"
          @click="addStoreDialog = true"
        >
          <v-icon dark>add</v-icon> {{ $t('store')}}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items.sync="stores"
      class="elevation-2 myDense"
      :rows-per-page-items="rowPerPage"

    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td>{{ props.item.accountId}}</td>
        <td>{{props.item.accountName}}</td>
        <td>{{ props.item.platform}}</td>
        <td>{{ props.item.countryCode || 'US'}}</td>
        <td>{{ props.item.status }}</td>
        <td>{{ props.item.isAuthorize}}</td>
        <td>{{toTimestampString(props.item.createTime) }}</td>
        <td text-xs-center>
          <v-layout row>
            <v-flex>
              <v-btn
                dark
                color="primary"
                flat
                @click.stop="toAuthorize(props.item)"
                >{{ props.item.isAuthorize? $t('reAuthorize'): $t('authorize')}}
              </v-btn>
            </v-flex>
            <v-flex >
              <v-btn
                dark
                color="primary"
                flat
                :loading="deleteStoreLoading && props.item.isLoading"
                @click.stop="deleteStore(props.item)"
                >{{$t('delete')}}</v-btn
              >
            </v-flex>
          </v-layout>
        </td>
      </template>
    </v-data-table>
    <FormSubmitPopup
      :title="$t('fillInStoreInformation')"
      v-model="addStoreDialog"
      v-if="addStoreDialog"
      :rightMethod="addStoreSubmitted"
      @popupClose="addStoreDialog = false"
      :rightButtonDisabled="!isEmpty"
      medium
    >
      <template v-slot:input>
        <v-flex md3>
          <v-autocomplete
            :items="platforms"
            v-model="platform"
            :label="$t('platform')"
          >
            <template v-slot:item="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title :id="data.item">
                    {{data.item}}
                  </v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex md3>
          <v-autocomplete
            :items="countryCodes"
            v-model="countryCode"
            :label="$t('countryCode')"
          >
            <template v-slot:item="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title :id="data.item">
                    {{data.item}}
                  </v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex md5>
          <v-text-field
            :label="$t('storeName')"
            v-model="accountName"
            :rules="[
              isDuplicateName
            ]"
            class="required_field"
          ></v-text-field>
        </v-flex>
      </template>
    </FormSubmitPopup>
    <FormSubmitPopup
      :title="$t('fillInAuthorizeInformation')"
      v-model="walmartAuthorizeDialog"
      v-if="walmartAuthorizeDialog"
      :rightMethod="walmartAuthorizeSubmit"
      @popupClose="walmartAuthorizeDialog = false"
      :rightButtonDisabled="!isWalmartAuthorizeEmpty"
      medium
    >
      <template v-slot:input>
        <template v-if="store.platform === 'walmart'">
          <v-layout>
            <v-flex md6>
              <v-text-field
                :label="$t('clientId')"
                v-model="authorizeClientId"
                :rules="[
                  isDuplicateName
                ]"
                class="required_field"
                ></v-text-field>
            </v-flex>
            <v-flex><v-btn dark flat color="primary" @click="authorizeHelp">{{$t('authorizeHelp')}}</v-btn></v-flex>
          </v-layout>
        <v-flex md6>
          <v-text-field
            :label="$t('clientSecret')"
            v-model="authorizeClientSecret"
            :rules="[
              isDuplicateName
            ]"
            class="required_field"
          ></v-text-field>
        </v-flex>
        </template>
        <template v-else>
          <v-layout>
            <v-flex md6>
              <v-text-field
                :label="$t('shopName')"
                v-model="authorizeClientId"
                :rules="[
                  isDuplicateName
                ]"
                class="required_field"
                ></v-text-field>
            </v-flex>
            <v-flex><v-btn dark flat color="primary" @click="authorizeHelp">{{$t('authorizeHelp')}}</v-btn></v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6>
              <v-text-field
                :label="$t('token')"
                v-model="accessToken"
                class="required_field"
                ></v-text-field>
            </v-flex>
          </v-layout>
        </template>

      </template>
    </FormSubmitPopup>
    <FormSubmitPopup
      :title="$t('fillInAuthorizeInformation')"
      v-model="shopifyAuthorizeDialog"
      v-if="shopifyAuthorizeDialog"
      :rightMethod="shopifyAuthorizeSubmit"
      @popupClose="shopifyAuthorizeDialog = false"
      :rightButtonDisabled="!isShopifyAuthorizeEmpty"
      medium
    >
      <template v-slot:input>
        <template>
          <v-layout>
            <v-flex md6>
              <v-text-field
                :label="$t('shopName')"
                v-model="authorizeClientId"
                :rules="[
                  isDuplicateName
                ]"
                class="required_field"
                ></v-text-field>
            </v-flex>
            <v-flex><v-btn dark flat color="primary" @click="authorizeHelp">{{$t('authorizeHelp')}}</v-btn></v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6>
              <v-text-field
                :label="$t('token')"
                v-model="accessToken"
                class="required_field"
                ></v-text-field>
            </v-flex>
          </v-layout>
        </template>

      </template>
    </FormSubmitPopup>

    <FormSubmitPopup
      :title="$t('fillInAuthorizeInformation')"
      :value="temuAuthorizeDialog"
      v-if="temuAuthorizeDialog"
      :rightMethod="temuAuthorizeSubmit"
      @popupClose="temuAuthorizeDialog = false"
      :rightButtonDisabled="isTemuAuthorizeEmpty"
      medium
    >
      <template v-slot:input>
        <v-layout justify-between-space>
          <v-flex md10>
            <v-text-field
              label="Access Token"
              v-model="temuForm.accessToken"
              :rules="[
                fieldIsRequired()
              ]"
              class="required_field"
            ></v-text-field>
          </v-flex>
          <v-flex md2>
            <v-btn dark flat color="primary" @click="authorizeHelp">{{$t('authorizeHelp')}}</v-btn>
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
    <HelpManualPopup
    ref="HelpManualPopup"
    :isShow="staticAuthorizeDialog"
    :title="$t('authorizeHelpDetails')"
    v-model="staticAuthorizeDialog"
    v-if="staticAuthorizeDialog"
    :helpManualFileUrl="platformAuthHelp"
    >
    </HelpManualPopup>
  </v-container>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup.vue'
import HelpManualPopup from './HelpManualPopup.vue'
import { checkRules, timeTools } from '@/utils/tools'

export default {
  name: 'storeSettings',
  components: {
    FormSubmitPopup,
    HelpManualPopup
  },
  mixins: [checkRules, timeTools],
  data () {
    return {
      editAddress: false,
      addStoreDialog: false,
      addressInEdit: {},
      valid: true,
      platforms: ['ebay', 'walmart', 'tiktok', 'shopify', 'temu', 'shein', 'shein_self'],
      platform: '',
      accountName: '',
      deleteStoreLoading: false,
      countryCodes: ['US'],
      countryCode: '',
      walmartAuthorizeDialog: false,
      authorizeClientId: '',
      authorizeClientSecret: '',
      accessToken: '',
      store: {},
      staticAuthorizeDialog: false,
      platformAuthHelp: '',
      temuAuthorizeDialog: false,
      temuForm: {
        // appKey: '',
        // appSecret: '',
        accessToken: ''
      },
      shopifyAuthorizeDialog: false
    }
  },
  computed: {
    isTemuAuthorizeEmpty () {
      const { 
        // appKey,
        // appSecret,
        accessToken
      } = this.temuForm
      return !accessToken
    },
    isWalmartAuthorizeEmpty () {
      return this.store.platform === 'walmart' ? !!this.authorizeClientId && !!this.authorizeClientSecret : !!this.authorizeClientId && !!this.accessToken
    },
    isShopifyAuthorizeEmpty () {
      return !!this.authorizeClientId && !!this.accessToken
    },
    isDuplicateName () {
      let isDuplicateName = this.stores.some(({accountName}) => this.accountName === accountName)
      return !isDuplicateName || this.$t('duplicateStoreName')
    },

    overStoreLimit () {
      return this.$store.getters.tenant.storeLimitMax || 100
    },
    headers () {
      return [
        { text: '#', sortable: false, value: '', align: 'center', width: 30 },
        { text: this.$t('id#'), align: 'left', sortable: false, width: '12%' },
        { text: this.$t('storeName'), align: 'left', sortable: false },
        { text: this.$t('platform'), align: 'left', sortable: false },
        { text: this.$t('countryCode'), align: 'left', sortable: false },
        { text: this.$t('status'), align: 'left', sortable: false },
        { text: this.$t('authorize'), align: 'left', sortable: false },
        { text: this.$t('createTime'), align: 'left', sortable: false },
        { text: this.$t('actions'), align: 'center', sortable: false, width: '6%' }
      ]
    },
    rowPerPage () {
      return [30, 50, {text: this.$t('all'), value: -1}]
    },
    stores () {
      return this.$store.getters.stores
    },
    isEmpty () {
      return !!this.platform && !!this.accountName && !!this.countryCode
    },
    warehousesSites () {
      return this.$store.getters.warehousesSites
    },
    activeWarehouse () {
      return this.$store.getters.activeWarehouse
    }
  },
  methods: {
    handleRequestError (error) {
      let errorMessage = error.toString().split('Error: ')[1]
      this.$store.dispatch('showToast',
        {
          info: this.$t(`EcomRequestError.${errorMessage.split(',')[0]}`, {message: errorMessage.split(',')[1] || ''}),
          level: 'error'
        })
    },
    authorizeHelp () {
      this.platformAuthHelp = `/${this.store.platform}AuthHelp.html`
      this.staticAuthorizeDialog = true
    },
    async walmartAuthorizeSubmit () {
      let payload = {
        type: 'walmartAuthorize',
        accountId: this.store.accountId,
        clientId: this.authorizeClientId.trim(),
        accessToken: this.accessToken,
        clientSecret: this.authorizeClientSecret.trim(),
        authorizer: this.$store.getters.userExtra.uid,
        authorizerName: this.$store.getters.userExtra.name
      }
      await this.$store.dispatch('processEcomRequest', payload)
        .then((res) => {
          this.$store.dispatch('showToast', {info: res, level: 'success'})
        })
        .catch((error) => {
          this.handleRequestError(error)
        })
        .finally(() => {
          this.authorizeClientId = ''
          this.authorizeClientSecret = ''
          this.store = {}
          this.walmartAuthorizeDialog = false
        })
    },
    async shopifyAuthorizeSubmit () {
      let payload = {
        type: 'shopifyAuthorize',
        accountId: this.store.accountId,
        clientId: this.authorizeClientId.trim(),
        accessToken: this.accessToken,
        clientSecret: this.authorizeClientSecret.trim(),
        authorizer: this.$store.getters.userExtra.uid,
        authorizerName: this.$store.getters.userExtra.name
      }
      await this.$store.dispatch('processEcomRequest', payload)
        .then((res) => {
          this.$store.dispatch('showToast', {info: res, level: 'success'})
        })
        .catch((error) => {
          this.handleRequestError(error)
        })
        .finally(() => {
          this.authorizeClientId = ''
          this.authorizeClientSecret = ''
          this.store = {}
          this.shopifyAuthorizeDialog = false
        })
    },
    async temuAuthorizeSubmit () {
      let payload = {
        type: 'temuAuthorize',
        accountId: this.store.accountId,
        clientId: this.temuForm.appKey?.trim() || '',
        clientSecret: this.temuForm.appSecret?.trim() || '',
        clientToken: this.temuForm.accessToken.trim(),
        authorizer: this.$store.getters.userExtra.uid,
        authorizerName: this.$store.getters.userExtra.name
      }
      await this.$store.dispatch('processEcomRequest', payload)
        .then((res) => {
          this.$store.dispatch('showToast', {info: res, level: 'success'})
          this.temuAuthorizeDialog = false
          this.temuForm = {
            // appKey: '',
            // appSecret: '',
            accessToken: ''
          }
          this.store = {}
        })
        .catch((error) => {
          this.handleRequestError(error)
        })
    },
    toAuthorize (item) {
      let payload = {
        accountName: item.accountName,
        authorizer: this.$store.getters.userExtra.uid,
        authorizerName: this.$store.getters.userExtra.name,
        clientId: item.tenantKey,
        accountId: item.accountId,
        platform: item.platform
      }
      if (['tiktok', 'ebay', 'shein', 'shein_self'].includes(item.platform)) {
        this.$store.dispatch('toAuthorize', payload)
      }
      if (item.platform === 'walmart') {
        this.walmartAuthorizeDialog = true
        this.store = item
      } else if (item.platform === 'temu') {
        this.temuAuthorizeDialog = true
        this.store = item
      } else if (item.platform === 'shopify') {
        this.shopifyAuthorizeDialog = true
        this.store = item
      }
    },
    deleteStore (item) {
      if (!confirm(this.$t('confirmDeleteStore'))) return
      this.deleteStoreLoading = true
      item.isLoading = true
      let payload = {
        type: 'deleteStore',
        testaccountId: item.accountId
      }
      this.$store.dispatch('processEcomRequest', payload)
        .catch((error) => {
          this.handleRequestError(error)
        })
        .finally(() => {
          this.deleteStoreLoading = false
        })
    },
    async addStoreSubmitted () {
      if (this.stores.length >= this.overStoreLimit) {
        alert(this.$t('storeLimitMax', {overStoreLimit: this.overStoreLimit}))
        return
      }
      let payload = {
        platform: this.platform,
        accountName: this.accountName,
        countryCode: this.countryCode,
        createTime: new Date()
      }
      await this.$store.dispatch('addStore', payload)
        .then(() => {
          this.platform = ''
          this.accountName = ''
          this.countryCode = ''
        })
        .catch((error) => {
          this.handleRequestError(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StoreSettings.vue